"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  quote: "JokerStudio a su capturer l'essence de nos événements avec un professionnalisme remarquable.",
  author: "Client A"
}, {
  id: 2,
  quote: "Une équipe créative et à l'écoute, le résultat dépasse nos attentes.",
  author: "Client B"
}];
export default function Testimonials() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section className="bg-background py-16 px-6">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-display text-foreground mb-12 text-center text-3xl font-bold md:text-4xl">
          Témoignages
        </h2>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          <div ref={ref1} data-index={0} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible1 ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
            <Card className="card hover-lift border-border h-full border transition-all duration-[var(--duration-medium)] hover:border-primary/40">
              <CardContent className="flex h-full flex-col justify-between">
                <p className="text-foreground mb-6 text-base leading-relaxed">
                  "{testimonials[0].quote}"
                </p>
                <p className="text-muted-foreground text-sm font-semibold">
                  — {testimonials[0].author}
                </p>
              </CardContent>
            </Card>
          </div>

          <div ref={ref2} data-index={1} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible2 ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"} delay-100`} style={{
          transitionDelay: "100ms"
        }}>
            <Card className="card hover-lift border-border h-full border transition-all duration-[var(--duration-medium)] hover:border-primary/40">
              <CardContent className="flex h-full flex-col justify-between">
                <p className="text-foreground mb-6 text-base leading-relaxed">
                  "{testimonials[1].quote}"
                </p>
                <p className="text-muted-foreground text-sm font-semibold">
                  — {testimonials[1].author}
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}